import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, Percent } from "lucide-react";
import { useLang } from "../../i18n";

export const WelcomePromo = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShow(true), 3300);
    return () => clearTimeout(id);
  }, []);

  const close = () => setShow(false);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 right-6 sm:right-auto sm:w-[360px] z-[70]"
        >
          <div data-testid="welcome-promo" className="bg-[#29221D] text-[#F3EFE6] p-6 shadow-[0_30px_60px_-20px_rgba(41,34,29,0.5)] border border-[#57534E]">
            <button data-testid="promo-close" onClick={close} className="absolute top-3 right-3 p-1 text-[#A8A29E] hover:text-[#F3EFE6] transition-colors" aria-label="Chiudi">
              <X className="w-4 h-4" />
            </button>
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-[#C18A53]/20 flex items-center justify-center shrink-0">
                <Percent className="w-4 h-4 text-[#C18A53]" />
              </span>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#C18A53]">{t("promo.title")}</p>
            </div>
            <p className="mt-3 text-sm text-[#D6CFC4] leading-relaxed">{t("promo.p")}</p>
            <a href="#contatti" onClick={close} data-testid="promo-cta" className="btn-pill mt-4 bg-[#C18A53] text-[#29221D] hover:!bg-[#FBF9F5] !py-2 !px-4 text-xs">
              {t("promo.cta")}
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
